<template>
    <div class="main-container">
        <my-header></my-header>
        <div class="container">
            <h1 style="text-align: center;font-size: 22px;">{{ extWFlowForm.bidItemName }}</h1>
            <div style="text-align: right; margin-top:20px; margin-right: 10px;"
                 v-if="canBidbackFlag == 1&&!isReadOnly">
                <el-button type="default" size="mini" @click="giveup()">弃标</el-button>
                <el-button type="default" size="mini" @click="saveToDraft()">保存</el-button>
                <el-button v-if="type == 2" type="primary" size="mini" @click="submit()">回标</el-button>
            </div>
            <section class="small-container">
                <h3 class="iconfont iconxiala">招标说明</h3>
                <el-row class="colorLine">
                    <el-col :span="10">
                        <div style="height: 1px;background: #91002c;"></div>
                    </el-col>
                    <el-col :span="14">
                        <div style="height: 1px;background: #003570;"></div>
                    </el-col>
                </el-row>
                <el-form :disabled="true" status-icon inline :model="wFlowFormInfo" ref="wFlowFormInfo"
                         :label-width="formLabelWidth">
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="招标单位：" prop="bidUnit" class="noMarginBottom">
                                <el-input v-model.trim="wFlowFormInfo.bidUnit"
                                          size="mini"
                                          class="minWidth"
                                          placeholder="请输入招标单位"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="工期要求：" prop="constructionRequirements" class="noMarginBottom">
                                <el-input v-model.trim="wFlowFormInfo.constructionRequirements"
                                          size="mini"
                                          class="minWidth"
                                          placeholder="请输入工期要求">
                                    <span slot="suffix">天</span>
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="招标开始时间：" prop="bidStartDate" class="noMarginBottom">
                                <el-date-picker
                                    v-model="wFlowFormInfo.bidStartDate"
                                    size="mini"
                                    class="minWidth"
                                    :clearable=false
                                    align="right"
                                    type="date"
                                    format="yyyy-MM-dd HH:mm:ss"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    placeholder="请选择日期">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="投标截止时间：" prop="bidEndDate" class="noMarginBottom">
                                <el-date-picker
                                    v-model="wFlowFormInfo.bidEndDate"
                                    size="mini"
                                    class="minWidth"
                                    :clearable=false
                                    align="right"
                                    type="date"
                                    format="yyyy-MM-dd HH:mm:ss"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    placeholder="请选择日期">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="投标范围/内容/要求：" prop="bidRanges" class="noMarginBottom maxWidthForm">
                                <el-input
                                    type="textarea"
                                    :maxlength="500"
                                    size="mini"
                                    :rows="5"
                                    placeholder="请输入内容"
                                    v-model="wFlowFormInfo.bidRanges"
                                >
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="质量要求/服务要求：" prop="qualityRequiements"
                                          class="noMarginBottom maxWidthForm">
                                <el-input
                                    v-model.trim="wFlowFormInfo.qualityRequiements"
                                    type="textarea"
                                    :maxlength="500"
                                    size="mini"
                                    :rows="5"
                                    placeholder="请输入质量要求/服务要求">
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </section>

            <!--支付节点-->
            <section class="small-container">
                <div class="line-display">
                    <h3 class="iconfont iconxiala">支付节点信息</h3>
                </div>

                <el-row class="colorLine">
                    <el-col :span="10">
                        <div style="height: 1px;background: #91002c;"></div>
                    </el-col>
                    <el-col :span="14">
                        <div style="height: 1px;background: #003570;"></div>
                    </el-col>
                </el-row>
                <div style="margin-left: 20px;">
                    <el-table :data="wFlowFormInfoPaymentList"
                              :header-cell-style="$root.tableHeaderStyle"
                              :cell-style="$root.tableCellStyle"
                              tooltip-effect="light"
                              size="mini"
                              style="width: 100%"
                    >
                        <el-table-column label="支付节点编号" type="index" fixed="left" width="140px">
                        </el-table-column>
                        <el-table-column
                            prop="paymentName"
                            label="支付节点名称">
                        </el-table-column>
                        <el-table-column
                            prop="paymentRatio"
                            label="支付比例（%）">
                        </el-table-column>
                        <el-table-column
                            v-if="extWFlowForm.finalAmount"
                            label="支付金额">
                            <template slot-scope="scope">
                                {{
                                    $root.accMul(parseFloat(extWFlowForm.finalAmount), parseFloat(scope.row.paymentRatio)) / 100
                                }}
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="paymentConditions"
                            label="支付条件">
                        </el-table-column>
                    </el-table>
                </div>
            </section>

            <section class="small-container">
                <h3 class="iconfont iconxiala">清单
                    <span style="color: #F56C6C;font-size: 12px;top: 0;left: 100px;">(报价清单必须填写)</span>
                </h3>
                <el-row class="colorLine">
                    <el-col :span="10">
                        <div style="height: 1px;background: #91002c;"></div>
                    </el-col>
                    <el-col :span="14">
                        <div style="height: 1px;background: #003570;"></div>
                    </el-col>
                </el-row>
                <div>
                    <el-form :model="wFlowFormInfo" :disabled="true" status-icon inline label-width="110px">
                        <el-row>
                            <el-col :span="12">
                                <!-- 报价方式（1：总价包干，2：单价包干） -->
                                <el-form-item label="报价方式：" style="margin-bottom: 0px;">
                                    <el-radio-group v-model="wFlowFormInfo.quotationMethod">
                                        <el-radio :label="1">总价包干</el-radio>
                                        <el-radio :label="0">单价包干</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </el-col>

                            <el-col :span="12">
                                <!-- 税率（1：固定税率，2：非固定税率） -->
                                <el-form-item label="税率：" style="margin-bottom: 0px;">
                                    <el-radio-group v-model="wFlowFormInfo.taxRatioMethod">
                                        <el-radio :label="1">固定税率</el-radio>
                                        <el-radio :label="2">非固定税率</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row v-if="extWFlowForm.estimatedAmount >= 100000">
                            <el-col :span="24">
                                <el-form-item label="建筑面积：" style="margin-bottom: 0px;width: 50%;">
                                    <el-input v-model.trim="wFlowFormInfo.constructArea" style="margin-bottom: 0px;"
                                              size="mini" class="width100">
                                        <span slot="suffix">m²</span>
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="单方：" style="margin-bottom: 0px;">
                                    <el-input v-model.trim="wFlowFormInfo.constructAreaPerM2"
                                              style="margin-bottom: 0px;"
                                              size="mini" class="width100">
                                        <span slot="suffix">元/m²</span>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item label="服务面积/机房面积/改造面积：" style="margin-bottom: 0px;width: 50%;">
                                    <el-input v-model.trim="wFlowFormInfo.serviceRenovationArea"
                                              style="margin-bottom: 0px;"
                                              size="mini" class="width100">
                                        <span slot="suffix">m²</span>
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="单方：" style="margin-bottom: 0px;">
                                    <el-input v-model.trim="wFlowFormInfo.serviceRenovationAreaPerM2"
                                              style="margin-bottom: 0px;"
                                              size="mini" class="width100">
                                        <span slot="suffix">元/m²</span>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item label="租赁面积：" style="margin-bottom: 0px;width: 50%;">
                                    <el-input v-model.trim="wFlowFormInfo.rentalArea" style="margin-bottom: 0px;"
                                              size="mini" class="width100">
                                        <span slot="suffix">m²</span>
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="单方：" style="margin-bottom: 0px;">
                                    <el-input v-model.trim="wFlowFormInfo.rentalAreaPerM2" style="margin-bottom: 0px;"
                                              size="mini" class="width100">
                                        <span slot="suffix">元/m²</span>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                    <el-form status-icon inline label-width="110px">
                        <el-form-item style="margin-bottom: 0;">
                            <el-form-item label="不含税合价：">
                                <el-input size="mini" style="width: 180px" v-model="sumNoTax" disabled></el-input>
                            </el-form-item>
                            <el-form-item label="含税合价：">
                                <el-input size="mini" style="width: 180px" v-model="sumTax" disabled></el-input>
                            </el-form-item>
                            <el-form-item label="税金：">
                                <el-input size="mini" style="width: 180px" v-model="tax" disabled></el-input>
                            </el-form-item>
                            <el-button size="mini" style="margin-left: 15px" :disabled="false" @click="sumPrice">查看合价
                            </el-button>
                        </el-form-item>
                    </el-form>
                    <div style="display: inline-flex;width: 100%;padding-top: 5px">
                        <span style="width: 95%"></span>
                        <el-upload
                            action=""
                            :show-file-list="false"
                            :multiple="false"
                            :http-request="beforeFileInput"
                            :on-error="uploadErr"
                            :on-success="uploadSuc">
                            <span v-if="this.type!=1" class="text-button f14"
                                  style="float: right;width: 60px;cursor: pointer;"><i class="iconfont icondaoru2"></i> 导入</span>
                        </el-upload>
                        <div>
                            <span v-if="this.type!=1" class="text-button f14"
                                  style="float: right;margin-left: 20px;width: 68px;cursor: pointer;"
                                  @click.stop="fileOutput"><i class="iconfont icondaochu"></i> 导出</span>
                        </div>
                    </div>
                    <div style="margin-bottom: 20px;margin-left: 20px;" v-show="1 == wflowFormListFlag">
                        <inventory_BigData ref="inventory_page" :readonly="false"
                                           :segments="wFlowFormInfo.segmentsNumber" :code="extWFlowForm.categoryCode"
                                           :parentCode="extWFlowForm.parentCategoryCode" page="bidBack"
                                           :taxRatioFlag="wFlowFormInfo.taxRatioMethod"
                                           :quotationFlag="wFlowFormInfo.quotationMethod"></inventory_BigData>
                    </div>
                    <div style="margin-bottom: 20px;margin-left: 20px;" v-show="1 != wflowFormListFlag">
                        <inventory ref="inventory" :readonly="isReadOnly" :segments="wFlowFormInfo.segmentsNumber"
                                   :code="extWFlowForm.categoryCode" :parentCode="extWFlowForm.parentCategoryCode"
                                   page="bidBack" :taxRatioFlag="wFlowFormInfo.taxRatioMethod"
                                   :quotationFlag="wFlowFormInfo.quotationMethod"></inventory>
                    </div>
                    <div style="margin-bottom: 20px;margin-left: 20px;" v-if="false">
                        <inventory
                            v-if="wFlowFormInfo.quotationMethod == 1 && extWFlowForm.estimatedAmount >= 100000 && isShowFlowFormList2"
                            style="margin-top: 10px;" :validateFlag="false" ref="inventory1" :readonly="isReadOnly"
                            :code="extWFlowForm.categoryCode" :parentCode="extWFlowForm.parentCategoryCode"
                            page="bidBack" :taxRatioFlag="wFlowFormInfo.taxRatioMethod"
                            :quotationFlag="wFlowFormInfo.quotationMethod" :type="2"></inventory>
                    </div>
                </div>
            </section>

            <!--附件-->
            <section class="small-container">
                <div class="line-display">
                    <h3 class="iconfont iconxiala">招标资料</h3>
                </div>
                <el-row class="colorLine">
                    <el-col :span="10">
                        <div style="height: 1px;background: #91002c;"></div>
                    </el-col>
                    <el-col :span="14">
                        <div style="height: 1px;background: #003570;"></div>
                    </el-col>
                </el-row>
                <!-- :disabled="isReadOnly"  -->
                <el-form status-icon inline :model="attachementVO" :label-width="formLabelWidth">
                    <el-row>
                        <!-- <el-col :span="24">
                            <el-form-item label="回传附件模板(需下载填写后回传)：" class="noMarginBottom attachmentForm">
                                <page-upload
                                        @finishUpload="(fileList)=>{this.finishUpload(57, fileList)}"
                                        :files="attachementVO.returnTemplateAttachments"
                                        :disable="isReadOnly"
                                        :attachmentType="57">
                                </page-upload>
                            </el-form-item>
                        </el-col> -->
                        <el-col :span="24">
                            <el-form-item label="投标人承诺书：" class="noMarginBottom attachmentForm">
                                <!-- <page-upload
                                        @finishUpload="(fileList)=>{this.finishUpload(76, fileList)}"
                                        :files="attachementVO.promiseFiles"
                                        :editFlag="false"
                                        :attachmentType="76">
                                </page-upload> -->
                                <a href="javascript:;"
                                   @click="toDownload('https://bidding-system-pro.oss-cn-beijing.aliyuncs.com/zcxt_prod/2020/11/28/%E6%8A%95%E6%A0%87%E6%89%BF%E8%AF%BA%E4%B9%A6%EF%BC%88%E4%BE%9B%E5%BA%94%E5%95%86%E4%B8%8B%E8%BD%BD%E5%9B%9E%E4%BC%A0%E6%96%87%E4%BB%B6%EF%BC%89.docx', '投标承诺书（供应商下载回传文件）.docx')"
                                   style="color:#0091FF;">投标人承诺书</a>
                                   &nbsp;&nbsp;<a href="javascript:;"  style="color:#0091FF;" @click="preview(1)">预览</a>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="招标文件和合同范本响应表：" class="noMarginBottom attachmentForm">
                                <!-- <page-upload
                                        @finishUpload="(fileList)=>{this.finishUpload(78, fileList)}"
                                        :files="attachementVO.exampleFiles"
                                        :editFlag="false"
                                        :attachmentType="78">
                                </page-upload> -->
                                <a href="javascript:;"
                                   @click="toDownload('https://bidding-system-pro.oss-cn-beijing.aliyuncs.com/zcxt_prod/2020/11/28/%E6%8B%9B%E6%A0%87%E6%96%87%E4%BB%B6%E5%92%8C%E5%90%88%E5%90%8C%E8%8C%83%E6%9C%AC%E7%9A%84%E5%9B%9E%E5%BA%94%E8%A1%A8%EF%BC%88%E4%BE%9B%E5%BA%94%E5%95%86%E4%B8%8B%E8%BD%BD%E5%9B%9E%E4%BC%A0%E6%96%87%E4%BB%B6%EF%BC%89.docx','招标文件和合同范本的回应表（供应商下载回传文件）.docx')"
                                   style="color:#0091FF;">招标文件和合同范本响应表</a>
                                   &nbsp;&nbsp;<a href="javascript:;"  style="color:#0091FF;" @click="preview(2)">预览</a>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="清单：" class="noMarginBottom attachmentForm">
                                <page-upload
                                    @finishUpload="(fileList)=>{this.finishUpload(203, fileList)}"
                                    :files="attachementVO.listQuotation"
                                    :disable="isReadOnly"
                                    :attachmentType="203">
                                </page-upload>
                                <!-- <div style="width:100%;display:flex;">
                                    <div style="width:100%">
                                        <page-upload
                                            @finishUpload="(fileList)=>{this.finishUpload(203, fileList)}"
                                            :files="attachementVO.listQuotation"
                                            :disable="isReadOnly"
                                            :attachmentType="203">
                                        </page-upload>
                                    </div>
                                    <div>
                                        <div style="margin-top:5px;" v-for="item in attachementVO.listQuotation" :key="item">
                                            <el-button type="text" v-if="attachementVO.listQuotation.length && type ==1 " size="mini" @click="preview(58,  item.attachPath, item.attachName)">预览</el-button>
                                        </div>
                                    </div>
                                </div> -->

                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="方案：" class="noMarginBottom attachmentForm">
                                <page-upload
                                    @finishUpload="(fileList)=>{this.finishUpload(58, fileList)}"
                                    :files="attachementVO.drawingAttachments"
                                    :editFlag="false"
                                    :attachmentType="58">
                                </page-upload>
                                <div>
                                    <a href="javascript:;" @click="openDrawingDetail(drawingFile1.id)" style="color:#0091FF;">{{drawingFile1.schemeDrawingName}}</a>
                                </div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="图纸：" class="noMarginBottom attachmentForm">
                                <page-upload
                                    @finishUpload="(fileList)=>{this.finishUpload(225, fileList)}"
                                    :files="attachementVO.drawingAttachments225"
                                    :editFlag="false"
                                    :attachmentType="225">
                                </page-upload>
                                <div>
                                    <a href="javascript:;" @click="openDrawingDetail(drawingFile2.id)" style="color:#0091FF;">{{drawingFile2.schemeDrawingName}}</a>
                                </div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="合同：" class="noMarginBottom attachmentForm">
                                <page-upload
                                    @finishUpload="(fileList)=>{this.finishUpload(59, fileList)}"
                                    :files="attachementVO.contractAttachments"
                                    :disable="isReadOnly"
                                    :attachmentType="59">
                                </page-upload>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="其他附件：" class="noMarginBottom attachmentForm">
                                <page-upload
                                    @finishUpload="(fileList)=>{this.finishUpload(77, fileList)}"
                                    :files="attachementVO.otherAttachments"
                                    :disable="isReadOnly"
                                    :attachmentType="77">
                                </page-upload>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </section>

            <!--附件-->
            <section class="small-container">
                <div class="line-display">
                    <h3 class="iconfont iconxiala">附件上传</h3>
                </div>
                <el-row class="colorLine">
                    <el-col :span="10">
                        <div style="height: 1px;background: #91002c;"></div>
                    </el-col>
                    <el-col :span="14">
                        <div style="height: 1px;background: #003570;"></div>
                    </el-col>
                </el-row>
                <el-form status-icon inline :model="attachementVO" ref="attachementVO" :rules="attachementVORules"
                         :label-width="formLabelWidth" style="margin:20px 0;">
                    <el-row>
                        <!-- <el-col :span="24">
                            <el-form-item label="回传附件：" prop="returnAttachments" class="noMarginBottom attachmentForm">
                                <page-upload
                                        @finishUpload="(fileList)=>{this.$refs['attachementVO'].clearValidate('returnAttachments');this.finishUpload(85, fileList)}"
                                        :files="attachementVO.returnAttachments"
                                        :editFlag="!isReadOnly"
                                        :attachmentType="85">
                                </page-upload>
                            </el-form-item>
                        </el-col> -->
                        <el-col :span="24">
                            <el-form-item label="回传附件-投标人承诺书：" prop="returnAttachments"
                                class="noMarginBottom attachmentForm">
                                <page-upload
                                    @finishUpload="(fileList)=>{this.$refs['attachementVO'].clearValidate('returnAttachments');this.finishUpload(92, fileList)}"
                                    :files="attachementVO.returnAttachments"
                                    :editFlag="!isReadOnly"
                                    :attachmentType="92">
                                </page-upload>
                                <!-- <div style="width:100%;display:flex;">
                                    <div style="width:100%">
                                        <page-upload
                                            @finishUpload="(fileList)=>{this.$refs['attachementVO'].clearValidate('returnAttachments');this.finishUpload(92, fileList)}"
                                            :files="attachementVO.returnAttachments"
                                            :editFlag="!isReadOnly"
                                            :attachmentType="92">
                                        </page-upload>
                                    </div>
                                    <div>
                                        <div style="margin-top:5px;" v-for="item in attachementVO.returnAttachments" :key="item">
                                            <el-button type="text" v-if="attachementVO.returnAttachments.length && type ==1 " size="mini" @click="preview(58,  item.attachPath, item.attachName)">预览</el-button>
                                        </div>
                                    </div>
                                </div> -->

                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="回传附件-招标文件和合同范本响应表：" prop="returnAttachments2"
                                          class="noMarginBottom attachmentForm">
                                <page-upload
                                    @finishUpload="(fileList)=>{this.$refs['attachementVO'].clearValidate('returnAttachments2');this.finishUpload(93, fileList)}"
                                    :files="attachementVO.returnAttachments2"
                                    :editFlag="!isReadOnly"
                                    :attachmentType="93">
                                </page-upload>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="回传附件-清单：" prop="returnAttachments3"
                                          class="noMarginBottom attachmentForm">
                                <page-upload @finishUpload="(fileList)=>{
                                    this.$refs['attachementVO'].clearValidate('returnAttachments3');this.finishUpload(204, fileList)}"
                                             :files="attachementVO.returnAttachments3"
                                             :editFlag="!isReadOnly"
                                             :attachmentType="204">
                                </page-upload>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="回传附件-其他：" class="noMarginBottom attachmentForm">
                                <page-upload
                                    @finishUpload="(fileList)=>{this.finishUpload(86, fileList)}"
                                    :files="attachementVO.otherReturnAttachments"
                                    :editFlag="!isReadOnly"
                                    :attachmentType="86">
                                </page-upload>
                            </el-form-item>
                            <span style="color: #F56C6C;font-size: 12px;line-height: 33px;top: 0;left: 100px;">请勿上传包含报价信息附件</span>
                        </el-col>
                    </el-row>
                </el-form>
            </section>
        </div>
        <bid-give-up ref="gvd" :wflowFormId="this.wflowFormId" :supplierId="this.supplierId"
                     :dealId="this.dealId"></bid-give-up>
    </div>
</template>

<script type="text/babel">
import MyHeader from '../common/Header.vue'
import MyFooter from '../common/Footer.vue'
import BidGiveUp from "./components/bidGiveUp";

export default {
    name: "bidReturnLower",
    components: {
        BidGiveUp,
        MyHeader, MyFooter
    },
    data() {
        return {
            drawingFile1: {},
            drawingFile2: {},
            visible: false,
            sumTax: '',
            sumNoTax: '',
            tax: '',
            wflowFormListFlag: null,
            tableHeaderStyle: Object.assign({}, this.$root.tableHeaderStyle, {'text-align': 'left',}),
            tableCellStyle: Object.assign({}, this.$root.tableCellStyle, {'text-align': 'left',}),
            formLabelWidth: '200px',
            type: this.$route.query.type ? this.$route.query.type : '2',//类型 1： 详情  2：编辑
            supplierId: window.sessionStorage.getItem('loginId'),
            canBidbackFlag: false,

            outerMapAttachmentOptions: {},
            mapAttachmentOptions: {},
            wFlowFormInfo: {
                quotationMethod: 1, //报价方式
                taxRatioMethod: 1, //税率
            },
            extWFlowForm: {},
            wFlowFormId: '',

            attachementVO: {
                returnTemplateAttachments: [],//回传附件模板
                listQuotation: [], // 清单报价
                drawingAttachments: [],//方案/图纸
                drawingAttachments225: [],//方案/图纸
                contractAttachments: [],//合同
                bidFileAttachments: [],//招标文件附件
                otherAttachments: [],//其他附件

                returnAttachments: [],
                returnAttachments2: [],//其他回传附件
                returnAttachments3: [],//清单报价附件

                otherReturnAttachments: [], //其他文件上传
            },

            wFlowFormInfoPaymentList: [{
                paymentName: '',
                paymentRatio: '',
                paymentConditions: '',
            }],
            isShowFlowFormList2: true,
            attachementVORules: {
                returnAttachments: [{
                    required: true,
                    message: '请选择投标人承诺书',
                    trigger: 'blur'
                }],
                returnAttachments2: [{
                    required: true,
                    message: '请选择招标文件和合同范本响应表',
                    trigger: 'blur'
                }],
                returnAttachments3: [{
                    required: true,
                    message: '请选清单',
                    trigger: 'blur'
                }],
            },
            paymentRules: {
                paymentName: [{
                    required: true,
                    message: '请输入款项名称',
                    trigger: 'blur'
                }
                ],
                paymentRatio: [{
                    required: true,
                    message: '请输入付款比例',
                    trigger: 'blur'
                },
                    {
                        type: 'number',
                        message: '只能输入数字'
                    }
                ],
                paymentConditions: [{
                    required: true,
                    message: '输入付款条件',
                    trigger: 'blur'
                }
                ],
            },
        }
    },
    created() {
        this.dealId = this.$route.params.dealId;
        this.getDetail();
    },
    computed: {
        isReadOnly() {
            if (this.type == 1) {
                return true;
            } else {
                return false;
            }
        },
    },
    mounted() {

    },
    methods: {
        // 预览
        preview (type, data,name) {
        if (type == 1) {
            window.open('https://bidding-system-pro.oss-cn-beijing.aliyuncs.com/zcxt_prod/2020/11/28/%E6%8A%95%E6%A0%87%E6%89%BF%E8%AF%BA%E4%B9%A6%EF%BC%88%E4%BE%9B%E5%BA%94%E5%95%86%E4%B8%8B%E8%BD%BD%E5%9B%9E%E4%BC%A0%E6%96%87%E4%BB%B6%EF%BC%89.pdf')
        } else if (type == 2) {
            window.open('https://bidding-system-pro.oss-cn-beijing.aliyuncs.com/zcxt_prod/2020/11/28/%E6%8B%9B%E6%A0%87%E6%96%87%E4%BB%B6%E5%92%8C%E5%90%88%E5%90%8C%E8%8C%83%E6%9C%AC%E7%9A%84%E5%9B%9E%E5%BA%94%E8%A1%A8%EF%BC%88%E4%BE%9B%E5%BA%94%E5%95%86%E4%B8%8B%E8%BD%BD%E5%9B%9E%E4%BC%A0%E6%96%87%E4%BB%B6%EF%BC%89.pdf')
        } else if (type == 58) {
            window.open(util.baseUrl+'/v1/public/download/preview_direct?token='+ window.localStorage.getItem('token')+'&attachmentPath='+data+'&attachmentName='+encodeURIComponent(name))
            // if (data) {
            //   data.forEach((imgObj)=>{
            //     window.open(util.baseUrl+'/v1/public/download/preview_direct?token='+ window.localStorage.getItem('token')+'&attachmentPath='+imgObj.attachPath+'&attachmentName='+encodeURIComponent(imgObj.attachName))
            //   })
            // }
            } else if (type == 225) {
            window.open(util.baseUrl+'/v1/public/download/preview_direct?token='+ window.localStorage.getItem('token')+'&attachmentPath='+data+'&attachmentName='+encodeURIComponent(name))
            // if (data) {
            //   data.forEach((imgObj)=>{
            //     window.open(util.baseUrl+'/v1/public/download/preview_direct?token='+ window.localStorage.getItem('token')+'&attachmentPath='+imgObj.attachPath+'&attachmentName='+encodeURIComponent(imgObj.attachName))
            //   })
            // }
            } else if (type == 59) {
            window.open(util.baseUrl+'/v1/public/download/preview_direct?token='+ window.localStorage.getItem('token')+'&attachmentPath='+data+'&attachmentName='+encodeURIComponent(name))
            // if (data) {
            //   data.forEach((imgObj)=>{
            //     window.open(util.baseUrl+'/v1/public/download/preview_direct?token='+ window.localStorage.getItem('token')+'&attachmentPath='+imgObj.attachPath+'&attachmentName='+encodeURIComponent(imgObj.attachName))
            //   })
            // }
            } else if (type == 77) {
            window.open(util.baseUrl+'/v1/public/download/preview_direct?token='+ window.localStorage.getItem('token')+'&attachmentPath='+data+'&attachmentName='+encodeURIComponent(name))
            // if (data) {
            //   data.forEach((imgObj)=>{
            //     window.open(util.baseUrl+'/v1/public/download/preview_direct?token='+ window.localStorage.getItem('token')+'&attachmentPath='+imgObj.attachPath+'&attachmentName='+encodeURIComponent(imgObj.attachName))
            //   })
            // }
            } else if (type == 203) {
            window.open(util.baseUrl+'/v1/public/download/preview_direct?token='+ window.localStorage.getItem('token')+'&attachmentPath='+data+'&attachmentName='+encodeURIComponent(name))
            // if (data) {
            //   data.forEach((imgObj)=>{
            //     window.open(util.baseUrl+'/v1/public/download/preview_direct?token='+ window.localStorage.getItem('token')+'&attachmentPath='+imgObj.attachPath+'&attachmentName='+encodeURIComponent(imgObj.attachName))
            //   })
            // }
            } else if (type == 57) {
            window.open(util.baseUrl+'/v1/public/download/preview_direct?token='+ window.localStorage.getItem('token')+'&attachmentPath='+data+'&attachmentName='+encodeURIComponent(name))
            // if (data) {
            //   data.forEach((imgObj)=>{
            //     window.open(util.baseUrl+'/v1/public/download/preview_direct?token='+ window.localStorage.getItem('token')+'&attachmentPath='+imgObj.attachPath+'&attachmentName='+encodeURIComponent(imgObj.attachName))
            //   })
            // }
            } else if (type == 209) {
            window.open(util.baseUrl+'/v1/public/download/preview_direct?token='+ window.localStorage.getItem('token')+'&attachmentPath='+data+'&attachmentName='+encodeURIComponent(name))
            // if (data) {
            //   data.forEach((imgObj)=>{
            //     window.open(util.baseUrl+'/v1/public/download/preview_direct?token='+ window.localStorage.getItem('token')+'&attachmentPath='+imgObj.attachPath+'&attachmentName='+encodeURIComponent(imgObj.attachName))
            //   })
            // }
            }
        },
        openDrawingDetail(id){
            window.open("#/drawingDetail?id=" + id)
        },
        giveup() {
            this.$refs['gvd'].visible = true;
        },
        sumPrice() {
            try {
                if (this.wflowFormListFlag) {
                    let id = this.type != 1 ? this.dealId : this.wflowFormId;
                    this.$root.getFunc('/v1/outerformflowHS/getFlowFromListTotal?extranet=1&dealId=' + id, (res) => {
                        this.sumTax = this.$root.rounding(res.data.data.sumTax);
                        this.sumNoTax = this.$root.rounding(res.data.data.sumNoTax);
                        this.tax = this.$root.rounding(res.data.data.tax);
                        if (this.wFlowFormInfo.constructArea) {
                            this.wFlowFormInfo.constructAreaPerM2 = (parseFloat(this.sumTax) / parseFloat(this.wFlowFormInfo.constructArea)).toFixed(2)
                        } else {
                            this.wFlowFormInfo.constructAreaPerM2 = ''
                        }
                        if (this.wFlowFormInfo.serviceRenovationArea) {
                            this.wFlowFormInfo.serviceRenovationAreaPerM2 = (parseFloat(this.sumTax) / parseFloat(this.wFlowFormInfo.serviceRenovationArea)).toFixed(2)
                        } else {
                            this.wFlowFormInfo.serviceRenovationAreaPerM2 = ''
                        }
                        if (this.wFlowFormInfo.rentalArea) {
                            this.wFlowFormInfo.rentalAreaPerM2 = (parseFloat(this.sumTax) / parseFloat(this.wFlowFormInfo.rentalArea)).toFixed(2)
                        } else {
                            this.wFlowFormInfo.rentalAreaPerM2 = ''
                        }
                    })
                    return
                }
                let listData = this.$refs['inventory'].getData();
                let sum1 = 0;
                let sum2 = 0;
                listData.forEach(item => {
                    if (item.quotationType != 2) {
                        if (!item.unitAmountWithTax) {
                            return
                        }
                        let tempDayAmount = 1;
                        if (item.dayAmount) {
                            tempDayAmount = parseFloat(item.dayAmount);
                        }
                        let tempServiceTime = 1;
                        if (item.serviceTime) {
                            tempServiceTime = parseFloat(item.serviceTime);
                        }
                        let amountWithTax = parseFloat(item.unitAmountWithTax) * parseFloat(item.quantities) * parseFloat(tempDayAmount) * parseFloat(tempServiceTime)
                        sum1 += parseFloat(amountWithTax)
                        sum2 += parseFloat((parseFloat(amountWithTax) / (1 + parseFloat(item.taxRatio) / 100)))
                    }
                })
                this.sumTax = Number.isNaN(sum1) ? '' : sum1.toFixed(2);
                this.sumNoTax = Number.isNaN(sum2) ? '' : sum2.toFixed(2);
                this.tax = Number.isNaN(sum1 - sum2) ? '' : (sum1 - sum2).toFixed(2);
                if (this.wFlowFormInfo.constructArea) {
                    this.wFlowFormInfo.constructAreaPerM2 = (parseFloat(this.sumTax) / parseFloat(this.wFlowFormInfo.constructArea)).toFixed(2)
                } else {
                    this.wFlowFormInfo.constructAreaPerM2 = ''
                }
                if (this.wFlowFormInfo.serviceRenovationArea) {
                    this.wFlowFormInfo.serviceRenovationAreaPerM2 = (parseFloat(this.sumTax) / parseFloat(this.wFlowFormInfo.constructArea)).toFixed(2)
                } else {
                    this.wFlowFormInfo.serviceRenovationAreaPerM2 = ''
                }
                if (this.wFlowFormInfo.rentalArea) {
                    this.wFlowFormInfo.rentalAreaPerM2 = (parseFloat(this.sumTax) / parseFloat(this.wFlowFormInfo.constructArea)).toFixed(2)
                } else {
                    this.wFlowFormInfo.rentalAreaPerM2 = ''
                }
            } catch (e) {
                this.sumTax = '';
                this.sumNoTax = '';
                this.tax = '';
            }
        },
        uploadSuc(res) {
            if (res.code === '1') {
                let that = this;
                this.$alert(res.msg, {
                    type: 'success',
                    callback: () => {
                        that.getDetail()
                    }
                });
            } else
                this.$alert('文件导入失败！', {type: 'error'})
        },
        uploadErr() {
            this.$alert('导入失败！')
        },
        beforeFileInput(param) {
            this.save(0, 0, (tn) => {
                if (tn)
                    this.fileInput(param, () => {
                        this.getDetail()
                    })
            }, false);
        },
        fileInput(param, fn) {
            let that = this;
            let formData = new FormData()
            formData.append('dealId', this.dealId)
            formData.append('taxRatioMethod', this.wFlowFormInfo.taxRatioMethod)
            formData.append('type', '')
            formData.append('file', param.file)
            formData.append('excelType', '5')
            this.$root.postHttp('/v1/outerformflowHS/modelExcelmportFileWithID', formData, function (res) {
                if (res.data.code === '1') {
                    that.$alert(res.data.msg, {
                        type: 'success',
                        callback: () => {
                            fn()
                        }
                    })
                }
            });
        },
        fileOutput() {
            let id = this.dealId;
            let url = this.$root.baseUrl + '/v1/outerformflowHS/public/exportBidList?dealId=' + id + '&parentCodeType=' + this.extWFlowForm.parentCategoryCode + '&codeType=' + this.extWFlowForm.categoryCode;
            window.location.href = url;
        },
        finishUpload(fileType, fileList, contactForm) {
            if (contactForm) {
                // contactForm.sAttaches = [...contactForm.secureAttachement, ...contactForm.contractAttachement];
            } else {
                if (fileType == 86 || fileType == 92 || fileType == 93 || fileType == 204) {
                    this.outerMapAttachmentOptions[fileType] = fileList;
                } else {
                    this.mapAttachmentOptions[fileType] = fileList;
                }
            }
        },
        saveToDraft() {
            this.save(0, 0, () => {
            });
        },
        submit() {
            let that = this;
            that.$confirm('回标信息提交之后将不能修改，请确认是否提交？', {
                type: 'warning'
            }).then(() => {
                this.checkForm().then((res) => {
                    if (Array.isArray(res)) {
                        this.save(1, 0, () => {
                            // that.$router.push('/bid/progress');
                            that.$router.go(-1);
                        });
                    } else {
                        this.$alert(res, {
                            type: 'warning'
                        });
                    }
                }).catch(e => {
                    console.log(e);
                });
            }).catch(() => {
                // 取消按钮回调
            });

        },
        checkForm() {
            let checkPromise = [];
            let listRef = this.$refs['inventory'];
            if (!this.wflowFormListFlag && listRef) {
                checkPromise.push(listRef.validate());
            }
            checkPromise.push(this.submitFormPromise('attachementVO'));

            return Promise.all(checkPromise).then(data => {
                return data;
            })
                .catch(e => {
                    console.log(e);
                    return e;
                    // reject(e);
                });
        },
        submitFormFnc(formName) {
            let that = this;
            var f = function () {
                const p = new Promise((resolve, reject) => {
                    let form = that.$refs[formName];
                    if (Array.isArray(that.$refs[formName])) {
                        form = that.$refs[formName][0]
                    }
                    form.validate((valid) => {
                        if (valid) {
                            resolve(true);
                        } else {
                            reject('请完成必填信息的填写！');
                        }
                    });
                });
                return p;
            }
            return f;
        },
        submitFormPromise(formName) {
            return this.submitFormFnc(formName)();
        },
        save(saveFlag, sendInviteFlag, fn, showTips = true) {
            // /v1/outerformflowHS/saveWFolwForm
            let that = this;

            let formParams = {
                bidBackSaveFlag: saveFlag,
                wflowFormId: this.wflowFormId,
                supplierId: this.supplierId,
                techScoreTemplateList: [],
                // outMapAttachmentVOs: this.outerMapAttachmentOptions,
                outMapAttachmentVOs: {},
                dealId: this.dealId,
                wflowFormListFlag: this.wflowFormListFlag
            };

            formParams.outMapAttachmentVOs = {};
            for (let key in this.outerMapAttachmentOptions) {
                formParams.outMapAttachmentVOs[key] = this.outerMapAttachmentOptions[key].fileList;
            }

            let listRef = this.$refs['inventory'];
            let listRef1 = this.$refs['inventory1'];

            // formParams = Object.assign({}, formParams, listRef.getData());
            if (listRef) {
                formParams.wflowFormListList = listRef.getData();
            }
            if (listRef1) {
                formParams.wflowFormListList2 = listRef1.getData();
            }

            this.$root.postHttp('/v1/outerformflowHS/bidBack', formParams, function (res) {
                if (showTips)
                    that.$alert('保存成功', '提示', {
                        confirmButtonText: '确定',
                        type: 'success',
                        callback: action => {

                        }
                    });
                fn(true);
            }, function () {
                fn(false);
            })
        },
        getType(type) {
            this.$root.getHttp('v1/sysDict/public/getDictListByDictType?dictType=' + type, (res) => {
                if (type == 'bid_evaluation_method') {

                }
            });
        },
        addPayment() {
            var item = {
                paymentName: '',
                paymentRatio: '',
                paymentConditions: '',
            };
            this.wFlowFormInfoPaymentList.push(item);
        },
        removePayment(index) {
            var form = 'payment' + index;
            this.$refs[form][0].resetFields();
            this.wFlowFormInfoPaymentList.splice(index, 1);
        },
        getDetail() {
            let that = this;
            this.$root.postHttp('/v1/outerformflowHS/getWFlowFormList', {dealId: this.dealId}, (res) => {
                res.data.data.wflowFormInfo.officeAddress = res.data.data.extWFlowForm.officeAddress;
                that.wflowFormListFlag = res.data.data.wflowFormListFlag;
                that.canBidbackFlag = res.data.data.canBidbackFlag;
                that.wFlowFormInfo = res.data.data.wflowFormInfo;
                that.extWFlowForm = res.data.data.extWFlowForm;
                that.wflowFormId = res.data.data.wflowFormId;
                that.wFlowFormInfoPaymentList = res.data.data.wflowFormInfoPaymentList;
                that.attachementVO.returnTemplateAttachments = res.data.data.mapAttachmentVOs[57] || [];
                that.attachementVO.drawingAttachments = res.data.data.mapAttachmentVOs[58] || [];
                that.attachementVO.drawingAttachments225 = res.data.data.mapAttachmentVOs[225] || [];
                that.attachementVO.listQuotation = res.data.data.mapAttachmentVOs[203] || [];
                that.attachementVO.contractAttachments = res.data.data.mapAttachmentVOs[59] || [];
                that.attachementVO.otherAttachments = res.data.data.mapAttachmentVOs[77] || [];
                that.attachementVO.returnAttachments = res.data.data.outMapAttachmentVOs[92] || [];
                that.attachementVO.returnAttachments2 = res.data.data.outMapAttachmentVOs[93] || [];
                that.attachementVO.returnAttachments3 = res.data.data.outMapAttachmentVOs[204] || [];
                that.attachementVO.otherReturnAttachments = res.data.data.outMapAttachmentVOs[86] || [];
                if(res.data.data.drawingId1){
                    that.drawingFile1.id = res.data.data.drawingId1
                    that.drawingFile1.schemeDrawingName = res.data.data.drawingName1
                }
                if(res.data.data.drawingId2){
                    that.drawingFile2.id = res.data.data.drawingId2
                    that.drawingFile2.schemeDrawingName = res.data.data.drawingName2
                }
                for (let key in res.data.data.mapAttachmentVOs) {
                    if (!that.mapAttachmentOptions[key]) {
                        that.mapAttachmentOptions[key] = {}
                    }
                    that.mapAttachmentOptions[key].fileList = res.data.data.mapAttachmentVOs[key];
                }
                // that.outerMapAttachmentOptions = res.data.data.outMapAttachmentVOs
                for (let key in res.data.data.outMapAttachmentVOs) {
                    if (!that.outerMapAttachmentOptions[key]) {
                        that.outerMapAttachmentOptions[key] = {}
                    }
                    that.outerMapAttachmentOptions[key].fileList = res.data.data.outMapAttachmentVOs[key];
                }

                if (that.extWFlowForm.ssuppliersCategory != null) {
                    that.extWFlowForm.categoryCode = that.extWFlowForm.ssuppliersCategory.categoryCode;
                    that.extWFlowForm.parentCategoryCode = that.extWFlowForm.ssuppliersCategory.parentCategoryCode;
                } else {
                    that.extWFlowForm.categoryCode = '';
                    that.extWFlowForm.parentCategoryCode = '';
                }

                if (res.data.data.extWFlowForm && res.data.data.extWFlowForm.ssuppliersCategory) {
                    that.extWFlowForm.categoryCode = res.data.data.extWFlowForm.ssuppliersCategory.categoryCode;
                    that.extWFlowForm.parentCategoryCode = res.data.data.extWFlowForm.ssuppliersCategory.parentCategoryCode;
                }
                let listRef = that.$refs['inventory'];
                let listRef_page = that.$refs['inventory_page'];
                let listRef1 = that.$refs['inventory1'];
                if (listRef_page && that.wflowFormListFlag == 1) {
                    listRef_page.setData(res.data.data.wflowFormListPage, {...res.data.data.wflowFormInfo, ...res.data.data.extWFlowForm.ssuppliersCategory, ...{dealId: this.dealId}});
                }
                if (listRef) {
                    listRef.setData(res.data.data.wflowFormListList, {...res.data.data.wflowFormInfo, ...res.data.data.extWFlowForm.ssuppliersCategory});
                }
                if (listRef1) {
                    if (res.data.data.wflowFormListList2.length == 0) {
                        that.isShowFlowFormList2 = false;
                    }
                    listRef1.setData(res.data.data.wflowFormListList2, {...res.data.data.wflowFormInfo, ...res.data.data.extWFlowForm.ssuppliersCategory});
                }
            });
        },
        toDownload(url, name) {
            window.location.href = url;
        },
    }
}
</script>

<style scoped lang="scss">
@import '../../assets/_var.scss';
@import "../../assets/iconfont/iconfont.css";

.main-container {
    width: 1100px;
    text-align: left;
}

.container /deep/ {
    margin-top: 60px;
    margin-bottom: 150px;
    padding-bottom: 15px;
    background-color: #ffffff;

    .el-form-item__error {
        width: 300px;
        text-align: left;
    }

    .text-button.el-button {
        font-size: 16px;
        text-align: left;
        color: #333333;
        line-height: 21px;
        background: white;
        border: none;
    }

    .f14 {
        font-size: 14px !important;
    }

    & .unit {
        width: 100px;
        margin-right: 5px;
    }

    & .tip {
        margin-left: 10px;
        color: $--primary-color;
        font-size: 12px;
    }

    & .add {
        float: right;
        font-size: 14px;
        cursor: pointer;

        & img {
            vertical-align: middle;
            width: 70px;
            height: 26px;
        }
    }

    & .dele {
        position: absolute;
        top: 0px;
        right: 10px;
    }

    & .dele img {
        transform: scale(1);
        transition: .5s;
        width: 34px;
        height: 34px;
    }

    .dele:hover img {
        transform: scale(1.1);
    }

    & .remarks {
        width: 95%;
    }

    & .naturalForm {
        padding: 20px 10px 5px;
        padding-left: 0px;
        padding-right: 26px;
        border: 1px solid #dcdfe6;
        border-radius: 3px;
        margin-bottom: 20px;
    }

    & h4 {
        padding: 0 30px;
        text-align: left;
        line-height: 50px;
        color: $--text-color-light;
        background: $--secondary-fill-color;
        overflow: hidden;
        position: relative;
    }

    & h4 {
        text-indent: 10px;
        line-height: 35px;
        background: $--primary-fill-color;
    }

    & h5 {
        padding: 0 30px;
    }

    .el-input__inner {
        border: none;
        border-bottom: 1px solid #C4C4C4;
        border-radius: 0px;
    }

    .el-input.is-disabled .el-input__inner, .el-textarea.is-disabled .el-textarea__inner {
        background-color: white;
        cursor: default;
    }

    .maxWidthForm {
        width: 100%;

        .el-form-item__content {
            width: calc(100% - 260px);
        }
    }

    .maxWidthForm-2 {
        width: 100%;

        .el-form-item__content {
            width: calc(100% - 100px);
        }
    }

    .el-form-item__error {
        width: 300px;
        padding: 0;
    }

    .el-form-item__label, .el-form-item__content {
        line-height: 33px;
    }

}

.box-card {
    margin-bottom: 15px;
}

.minWidth {
    width: 250px;
}

h3 {
    // background-color: #ececec;
    padding: 5px 20px;
    margin: 0;
    // margin-top: 10px;
    position: relative;
    cursor: pointer;
}

.iconxiala::before {
    position: absolute;
    left: -5px;
    font-size: 20px;
}

.colorLine {
    margin-bottom: 20px;
    padding-left: 20px;
}

h2 {
    font-size: 13px;
    margin-left: 20px;
}

.noMarginBottom {
    // margin-bottom: 0!important;
    margin-bottom: 10px !important;

    .tipWrap {
        position: relative;
        min-width: 250px;

        .tips {
            position: absolute;
            top: 16px;
            left: 100px;
            padding-left: 20px;
            font-size: 12px;
            color: $--text-color-light;
            background: url('../../assets/images/register/tip.png') no-repeat left center;
        }
    }
}

.cf:before,
.cf:after {
    content: "";
    display: table;
}

.cf:after {
    clear: both;
}

.attachmentDiv /deep/ {
    text-align: left;

    .file-list {
        margin-top: 10px;
    }

    .file-button {
        margin-top: -5px;
    }
}

</style>



// WEBPACK FOOTER //
// src/pages/bid/bidReturnLower.vue